import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { InputField } from '../../../components/ui/input-field';
import { FormSelect } from '../../../components/ui/select';
import { Search } from 'lucide-react';
import { trainingFlowsApi } from '../../agents/services/trainingFlowsApi';
import { agentsApi } from '../../agents/services/agentsApi';
import InboxListView from '../components/InboxListView';

export default function Inbox() {
  const [searchParams] = useSearchParams();
  const initialLeadId = searchParams.get('leadId') || undefined;
  const initialAgentId = searchParams.get('agentId') || '';

  const [selectedFlowId, setSelectedFlowId] = useState<string>('');
  const [selectedAgentId, setSelectedAgentId] = useState<string>(initialAgentId);
  const [flows, setFlows] = useState<{ id: string; nombre: string }[]>([]);
  const [agents, setAgents] = useState<{ id: string; nombre: string }[]>([]);

  useEffect(() => {
    const loadFilters = async () => {
      try {
        const [flowsData, agentsData] = await Promise.all([
          trainingFlowsApi.listFlows(),
          agentsApi.listAgents(),
        ]);
        setFlows(flowsData);
        setAgents(agentsData);
      } catch (error) {
        console.error('Error loading filters:', error);
      }
    };
    loadFilters();
  }, []);

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)] bg-background">
      {/* Header */}
      <div className="bg-white border-b border-grey-200 px-6 py-4 flex-shrink-0">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-foreground font-montserrat">Conversaciones</h1>
          <div className="flex items-center gap-4">
            <div className="relative w-64">
              <InputField
                label=""
                name="search"
                value=""
                onChange={() => {}}
                placeholder="Buscar"
                className="pl-10 bg-background border-maxi-border"
                icon={<Search className="w-5 h-5 text-[#BDBDBD] flex-shrink-0" />}
              />
            </div>
            <div className="w-40">
              <FormSelect
                label=""
                value={selectedFlowId}
                onChange={(value) => setSelectedFlowId(value)}
                options={[
                  { value: '', label: 'Todos los flows' },
                  ...flows.map((f) => ({ value: f.id, label: f.nombre })),
                ]}
                placeholder="Flow"
                className="w-full"
              />
            </div>
            <div className="w-40">
              <FormSelect
                label=""
                value={selectedAgentId}
                onChange={(value) => setSelectedAgentId(value)}
                options={[
                  { value: '', label: 'Todos los agentes' },
                  ...agents.map((a) => ({ value: a.id, label: a.nombre })),
                ]}
                placeholder="Agente"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Chat view */}
      <div className="flex-1 min-h-0">
        <InboxListView
          selectedFlowId={selectedFlowId || undefined}
          selectedAgentId={selectedAgentId || undefined}
          initialLeadId={initialLeadId}
        />
      </div>
    </div>
  );
}
